

module.exports = __webpack_require__.stylable.create(
    "OverlappingCard255404364",
    {"classes":{"root":"OverlappingCard255404364__root","infoContainer":"OverlappingCard255404364__infoContainer","mediaContainer":"OverlappingCard255404364__mediaContainer"},"vars":{},"stVars":{"DefaultInfoCardBG":"color-1","DefaultMediaCardBG":"color-5","DefaultBorderColor":"color-5","DefaultBorderWidth":"1","MainBorderWidth":"--overridable","MainBorderColor":"--overridable","MainInfoColor":"--overridable","MainMediaColor":"--overridable","borderWidth":"\"unit(fallback(zeroAsTrue(--overridable), 1), px)\"","borderColor":"\"color(fallback(--overridable, color-5))\"","infoBGColor":"\"color(fallback(--overridable, color-1))\"","mediaBGColor":"\"color(fallback(--overridable, opacity(color(color-5), 0.2)))\"","infoPadding":"60px","negativeInfoPadding":"-60px","MinWidth":"700px"},"keyframes":{}},
    "",
    3,
    "OverlappingCard255404364",
    null
);
